import { variables, $ } from '../common/variables';
import { cl, ajax } from '../common/functions';

const optionsActions = () => {
  const dataSourceInputs = document.querySelectorAll(`.bootstrap-scope input[type="radio"][name="data-source"]`);
  !!dataSourceInputs.length && [...dataSourceInputs].forEach(input => {
    input.addEventListener('click', (e) => {
      const dataBaseInputRadio = document.querySelector(`.bootstrap-scope input[type="radio"][name="data-source"][data-value="database"]`);
      const dataSourceOptions = document.querySelectorAll(`.bootstrap-scope .data_source--options`);
      if (dataBaseInputRadio && !!dataSourceOptions.length) {
        if (dataBaseInputRadio.checked) {
          [...dataSourceOptions].forEach(element => {
            element.classList.add('is-hidden');
          });
        }else{
          [...dataSourceOptions].forEach(element => {
            element.classList.remove('is-hidden');
          });
        }
      }
    });
  });
}

export { optionsActions }
